// extracted by mini-css-extract-plugin
export default {"secondText":"style_secondText__i5Ry7","link":"style_link__L-qF+"};